import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'
import { CheckCircleOutline, ErrorOutline } from '@material-ui/icons'
import { useAnalysisContext } from './contextProvider'

export default function SubmitStatusModal(): JSX.Element {
  const { modalState, closeModal } = useAnalysisContext()

  return (
    <Dialog open={modalState.open} onClose={closeModal} maxWidth='xs' fullWidth>
      <DialogTitle>
        {modalState.status === 'loading' && 'Processing Submission'}
        {modalState.status === 'success' && 'Submission Successful'}
        {modalState.status === 'error' && 'Submission Failed'}
      </DialogTitle>
      <DialogContent style={{ textAlign: 'center', padding: '20px' }}>
        {modalState.status === 'loading' && (
          <CircularProgress size={50} color='primary' />
        )}

        {modalState.status === 'success' && (
          <>
            <CheckCircleOutline style={{ fontSize: 50, color: 'green' }} />
            <Typography>{modalState.message}</Typography>
          </>
        )}

        {modalState.status === 'error' && (
          <>
            <ErrorOutline style={{ fontSize: 50, color: 'red' }} />
            <Typography>{modalState.message}</Typography>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}
